import { FC } from 'react';
import BrandLogo from './BrandLogo';
import UserMenu from './UserMenu';
import Search from '../../../features/search/Search';
import ContactUs from '../../../features/contact-us/ContactUs';
import UserGuide from '../../../features/user-guide/UserGuide';
import { selectIsUserSubscribedToHorizon } from '../../sharedSelectors';
import { useAppSelector } from '../../../core/rootHooks';

const Header: FC = () => {
	
	const isUserSubscribedToHorizon = useAppSelector(selectIsUserSubscribedToHorizon);

	return (
		<div style={{ width: '100%' }}>
			<div className="flex items-center justify-between">
				<div className="flex-1">
					<BrandLogo isUserSubscribedToHorizon={isUserSubscribedToHorizon} horizonUrl={isUserSubscribedToHorizon ? window.config?.HORIZON_APP_URL : '' }/>
				</div>
				<div className="flex-initial min-w-[320px] max-w-lg">
					<Search />
				</div>
				<div className="flex-1 flex items-center space-x-4 justify-end">
					<UserGuide />
					<ContactUs />
					<UserMenu  isUserSubscribedToHorizon={isUserSubscribedToHorizon}/>
				</div>
			</div>
		</div>
	);
};

export default Header;
